import "@hotwired/turbo-rails";
import "trix";
import "@rails/actiontext";

import { Tooltip } from "bootstrap";

import Choices from "choices.js";

import "~/javascript/channels/index.js";
import { setupFileUpload, setupMultiFileUpload } from "~/javascript/fileUpload.js"
import { setupVideoEditListeners } from "~/javascript/videos.js"
import { setupUsersEditListeners } from "~/javascript/users.js"
import { setupAnalytics, setupDatePicker } from "~/javascript/analytics.js"

document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".upload-file").forEach(fileInput => {
    setupFileUpload(fileInput);
  });

  document.querySelectorAll("#upload-multiple-files").forEach(dashboardContainer => {
    setupMultiFileUpload(dashboardContainer);
  });

  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltipTriggerEl) => {
    new Tooltip(tooltipTriggerEl);
  });

  document.querySelectorAll('select').forEach((selectEl) => {
    new Choices(selectEl, {
      searchResultLimit: -1,
      noResultsText: 'Aucun choix ne correspond à votre recherche',
      noChoicesText: "Aucun choix n'est disponible",
      itemSelectText: 'Appuyez pour sélectionner',
      addItemText: (value) => `Appuyez sur entrée pour ajouter <b>"${value}"</b>`,
      removeItemIconText: () => `Supprimer`,
      removeItemLabelText: (value) => `Supprimer: ${value}`,
    });
  });

  var newVideoModal = document.getElementById('newVideoModal')
  newVideoModal?.addEventListener('hidden.bs.modal', function (event) {
    window.location.reload();
  });

  setupVideoEditListeners();
  setupUsersEditListeners();

  setupAnalytics();
  setupDatePicker();
});
